import {PageOpenIn} from "@enums/PageOpenIn";
import {ToRef} from "@vue/runtime-core";
import {computed, ComputedRef, effectScope, nextTick, ref} from "vue";
import {f7} from "framework7-vue";
import {ServiceFAQButtons} from "@/services/v2/service-faq-buttons/ServiceFAQButtons";
import ModelFAQButtonLangSettings from "@models/v2/firebase/faq-buttons/ModelFAQButtonLangSettings";

export default class ViewFAQController {
  private _scope = effectScope(true);
  private static _instance: ViewFAQController | null = null;
  public openIn: ToRef<PageOpenIn> = ref(PageOpenIn.PAGE);
  public insidePopup: ToRef<boolean> = ref(false);
  public readonly _url: ComputedRef<ModelFAQButtonLangSettings | null>;
  private _serviceFAQButtons = ServiceFAQButtons.of();

  constructor() {
    this._url = this._scope.run(() => computed(() => {
      const history = f7.view.current.router.history;
      switch (history[history.length - 1].split('?')[0]) {
        case "/payments":
          return this._serviceFAQButtons.paymentsViewButton.value;
        case "/settings":
          return this._serviceFAQButtons.settingsViewButton.value;
        case "/auth/login":
          return this._serviceFAQButtons.loginViewButton.value;
        default:
          return null;
      }
    })) as ComputedRef<ModelFAQButtonLangSettings | null>
  }


  public static of() {
    if (this._instance === null) this._instance = new ViewFAQController();
    return this._instance;
  }

  get url() {
    return this._url;
  }
}
